import Vue from 'vue'
import router from '@/router'

/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth (key) {
    return JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf(key) !== -1 || false
}


/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate (data, id = 'id', pid = 'parentId') {
    var res = []
    var temp = {}
    for (var i = 0; i < data.length; i++) {
        temp[data[i][id]] = data[i]
    }
    for (var k = 0; k < data.length; k++) {
        if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
            if (!temp[data[k][pid]]['children']) {
                temp[data[k][pid]]['children'] = []
            }
            if (!temp[data[k][pid]]['_level']) {
                temp[data[k][pid]]['_level'] = 1
            }
            data[k]['_level'] = temp[data[k][pid]]._level + 1
            temp[data[k][pid]]['children'].push(data[k])
        } else {
            res.push(data[k])
        }
    }
    return res
}

export function buildTree(list){
  let temp = [];
  let tree = [];
  for(let i in list){
    // temp[list[i].id] = list[i];
    temp.push(list[i]);
  }
  for(let i in temp){
    if(temp[i].parentId) {
      if(!temp[temp[i].parentId].children) {
        temp[temp[i].parentId].children = [];
      }
      temp[temp[i].parentId].children.push(temp[i]);
    } else {
      tree.push(temp[i]);
    }
  }
  return tree;
}

/**
 * 清除登录信息
 */
export function clearLoginInfo () {
  router.options.isAddDynamicMenuRoutes = false
}


// WEBPACK FOOTER //
// ./src/utils/index.js